import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter,
  Output, ViewChild, Input, OnInit, ViewChildren, QueryList,
} from '@angular/core';
import 'rxjs/add/operator/takeWhile';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { digitalAssetsSegmentData, AssetFieldItem } from 'shared/digital-assets/digital-assets-segment-data';
import {
  additionalData,
  additionalHeight,
  additionalThirdPartyHeight,
  loopingData,
  mainData,
  previewWidth,
  searchFieldWidth
} from './table-data';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn} from '@angular/forms';
import * as utils from 'utils/utils';
import {PrettifySizePipe} from 'shared/pipes/prettify-size.pipe';
import {SegmentFieldItem} from 'utils/segment-field-item.interface';
import * as dateUtils from 'utils/date';
import {Option} from 'shared/form/select/option.interface';
import * as _ from 'lodash';
import {DigitalAssetsService} from 'shared/digital-assets/digital-assets.service';
import {Observable} from 'rxjs/Observable';
import {ErrorModalComponent} from 'shared/modal/error-modal/error-modal.component';
import { thirdPartyAssetTypeLookup } from 'shared/digital-assets/digital-assets-lookups';
import { of } from 'rxjs';
import { finalize, takeWhile, catchError } from 'rxjs/operators';
import {DetailsControlComponent} from 'shared/details-page/details-control/details-control.component';
import {getAvailableLanguages, getFieldTitleByFieldMap} from 'utils/utils';
import {createScoreFieldRequiredValidation} from 'shared/validation/scorecard-field-validation';


@Component({
  moduleId: module.id,
  selector: 'add-url-modal',
  templateUrl: 'add-url-modal.component.html',
  styleUrls: ['add-url-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddUrlModalComponent extends BaseModalComponent implements OnInit {

  @Input() assignedAsset: any;
  @Input() brandId: string;

  @Output() saveAssets: EventEmitter<any> = new EventEmitter();
  @Output() removeAssets: EventEmitter<any> = new EventEmitter();

  @ViewChild(ModalHeaderSearchComponent, {static: false})
  headerSearch: ModalHeaderSearchComponent;
  @ViewChild('errorModal', {static: false})
  private errorModal: ErrorModalComponent;

  @ViewChildren('loopingControl')
  loopingControls: QueryList<DetailsControlComponent>;

  segmentData: Array<AssetFieldItem> = digitalAssetsSegmentData;

  mainData: any[] = mainData;
  additionalData: any[] = additionalData;
  loopingData: any[] = loopingData;

  searchFieldWidth = searchFieldWidth;
  previewWidth = previewWidth;
  additionalHeight = additionalHeight;
  additionalThirdPartyHeight = additionalThirdPartyHeight;

  selectedLanguageItem: any;
  languageItems: Array<any> = [];
  loopingFields: Array<string> = ['asc', 'des'];

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    'filename': new UntypedFormControl(),
    'file_path': new UntypedFormControl(),
    'asset_type': new UntypedFormControl(),
    'representation': new UntypedFormControl(),

    'description': new UntypedFormControl(),
    'additional_info': new UntypedFormControl(),
    'color_mode': new UntypedFormControl(),
    'resolution': new UntypedFormControl(),
    'background': new UntypedFormControl(),
    'orientation_view': new UntypedFormControl(),
    'file_date_modified': new UntypedFormControl(),
    'effective_date': new UntypedFormControl(),
    'expiration_date': new UntypedFormControl(),
    'country': new UntypedFormControl(),
    'language': new UntypedFormControl(),

    'file_type': new UntypedFormControl(),
    'width': new UntypedFormControl(),
    'height': new UntypedFormControl(),
    'uom': new UntypedFormControl(),
    'file_size': new UntypedFormControl(),
    'third_party_asset': new UntypedFormControl(),

    'thumbnail': new UntypedFormControl(), // asset preview
    'origin_id': new UntypedFormControl(),

    'frame': new UntypedFormControl(),
    'total_frame': new UntypedFormControl(),
    'hemisphere': new UntypedFormControl(),
    'plunge': new UntypedFormControl(),
    'plane': new UntypedFormControl(),
    'total_planes': new UntypedFormControl(),
    'duration': new UntypedFormControl(),
    'duration_uom': new UntypedFormControl(),
    'descriptions': new UntypedFormControl(),
  });

  isExpanded: boolean = true;

  searchAssetArray: any[] = [];
  errorModalTitle: string = '';

  constructor(
    private ref: ChangeDetectorRef,
    private prettifySizePipe: PrettifySizePipe,
    protected digitalAssetsService: DigitalAssetsService,
    protected fb: UntypedFormBuilder,
  ) {
    super();
  }

  ngOnInit() {
    this.languageItems = getAvailableLanguages();
    this.onShown
      .pipe(takeWhile(() => this.isActive))
      .subscribe(() => {
        if (this.assignedAsset) {
          this.formGroup.patchValue({
            'filename': this.assignedAsset.value.filename,
            'file_path': this.assignedAsset.value.file_path || this.assignedAsset.value.uri,
            'asset_type': this.assignedAsset.value.asset_type,
            'representation': this.assignedAsset.value.representation,

            'description': this.assignedAsset.value.description,
            'additional_info': this.assignedAsset.value.additional_info,
            'color_mode': this.assignedAsset.value.color_mode,
            'resolution': this.assignedAsset.value.resolution,
            'background': this.assignedAsset.value.background,
            'orientation_view': this.assignedAsset.value.orientation_view,
            'file_date_modified': this.assignedAsset.value.file_date_modified,
            'effective_date': this.assignedAsset.value.effective_date,
            'expiration_date': this.assignedAsset.value.expiration_date,
            'country': this.assignedAsset.value.country,
            'language': this.assignedAsset.value.language,

            'file_type': this.assignedAsset.value.file_type,
            'width': this.assignedAsset.value.width,
            'height': this.assignedAsset.value.height,
            'uom': this.assignedAsset.value.uom,
            'file_size': this.assignedAsset.value.file_size,

            'thumbnail': this.assignedAsset.value.thumbnail,
            'origin_id': this.assignedAsset.value.origin_id,

            'frame': this.assignedAsset.value.frame,
            'total_frame': this.assignedAsset.value.total_frame,
            'hemisphere': this.assignedAsset.value.hemisphere,
            'plunge': this.assignedAsset.value.plunge,
            'plane': this.assignedAsset.value.plane,
            'total_planes': this.assignedAsset.value.total_planes,
            'duration': this.assignedAsset.value.duration,
            'duration_uom': this.assignedAsset.value.duration_uom,
            'descriptions': this.assignedAsset.value.descriptions,
          });
        } else {
          this.formGroup.patchValue({
            'filename': null,
            'file_path': null,
            'asset_type': null,
            'representation': null,

            'description': null,
            'additional_info': null,
            'color_mode': null,
            'resolution': null,
            'background': null,
            'orientation_view': null,
            'file_date_modified': null,
            'effective_date': null,
            'expiration_date': null,
            'country': null,
            'language': null,

            'file_type': null,
            'width': null,
            'height': null,
            'uom': null,
            'file_size': null,
            'third_party_asset': null,

            'thumbnail': null,
            'origin_id': null,

            'frame': null,
            'total_frame': null,
            'hemisphere': null,
            'plunge': null,
            'plane': null,
            'total_planes': null,
            'duration': null,
            'duration_uom': null,
            'descriptions': null,
          });
        }
        this.ref.markForCheck();
      });
  }

  get isCanSave(): boolean {
    return !!this.formGroup.controls.filename.value
      && (!!this.assignedAsset || !!this.formGroup.controls.file_path.value)
      && (!this.assignedAsset || !!this.formGroup.controls.asset_type.value);
  }

  get modalTitle(): string {
    return this.assignedAsset ? 'Edit Marketing Copy Asset' : 'Add asset URL';
  }

  get thumbnailUrl(): string {
    return this.formGroup.controls.thumbnail && this.formGroup.controls.thumbnail.value;
  }

  get isThirdPartyAsset(): boolean {
    return !this.assignedAsset || this.formGroup.value.third_party_asset === 1;
  }

  get selectedLanguageLower(): string {
    return _.toLower(this.selectedLanguage);
  }

  get selectedLanguage(): string {
    return _.get(this.selectedLanguageItem, 'code', 'EN');
  }

  onModalHide() {
    this.hide();
  }

  onSaveClick() {
    if (!this.isCanSave) { return; }
    const assetValue = {
      ...this.formGroup.value,
      uri: this.formGroup.value.file_path,
      height: Number(this.formGroup.value.height),
      width: Number(this.formGroup.value.width)
    };

    if (this.assignedAsset) {
      this.saveAssets.emit(assetValue);
      this.hide();
      return;
    }

    this.digitalAssetsService.postThirdPartyUriAsset(this.brandId, _.omit(assetValue, ['asset_type', 'origin_id', 'file_path']))
      .pipe(catchError((err) => {
        this.errorModalTitle = err;
        this.errorModal.show();
        return of(undefined);
      }))
      .subscribe((res: any) => {
        if (!res) { return; }
        const preparedAsset = {
          ...assetValue,
          origin_id: res.origin_id,
          system_filename: res.system_filename,
        };
        this.saveAssets.emit(preparedAsset);
        this.hide();
      });
  }

  onRemoveClick() {
    this.removeAssets.emit(this.formGroup);
    this.hide();
  }

  onCollapseClick() {
    this.isExpanded = !this.isExpanded;
  }

  onLanguageChange(event: any) {
    this.selectedLanguageItem = event;
    this.ref.markForCheck();
  }

  onAddAnotherClick(item, language: string) {
    // const validators: any = this.getFieldValidators(item);
    const validators: any = null;

    const formArray: any = this.getLoopingformArray(item.fieldName, language);
    formArray.push(new UntypedFormControl('',  validators));
    // this.scorecardConnectorService.controlAdded.emit({
    //   item, index: formArray.length - 1, language: this.selectedLsanguage,
    // });
    // _.defer(() => {
    //   this.focusOnLastLoopingControl(item.field_map);
    //   this.markAsDirty();
    // });
  }

  onDeleteControlClick(control: UntypedFormControl, item, language: string) {
    const formArray: any = this.getLoopingformArray(item.fieldName, language);
    if (!formArray) { return console.warn('formArray not found!'); }
    const index = formArray.controls.indexOf(control);
    formArray.removeAt(index);
    // this.scorecardConnectorService.controlRemoved.emit({
    //   item, index, language: this.selectedLanguage,
    // });
    // this.markAsDirty();
  }


  public hide(): void {
    this.reset();
    super.hide();
  }

  private reset(): void {
    this.headerSearch.reset();
  }

  public getFieldTitle(name: string): string {
    if (this.loopingFields.indexOf(name) >= 0) {
      return utils.getFieldTitleByFieldMap(name, this.segmentData);
    }
    return utils.getFieldTitle(name, this.segmentData);
  }

  protected getLookup(name: string, segmentData: Array<SegmentFieldItem>): any {
    if (name === 'asset_type' && this.isThirdPartyAsset) {
      return thirdPartyAssetTypeLookup;
    }
    return utils.getLookup(name, segmentData);
  }

  protected getTypeahead(formGroup: UntypedFormGroup, fieldName: string) {
    return this.searchAssetArray;
  }

  protected getTypeaheadOptionField(fieldName: string) {
    return 'filename';
  }

  isLoopingField(item: any): boolean {
    return (item.type === 'list');
  }

  getLoopingformArray(fieldMap: string, language: string): UntypedFormArray {
    return this.formGroup.controls[fieldMap] as UntypedFormArray;
    // return this.fb.array([]) as FormArray;
    // return new FormArray([]);
    // return this.formGroup.controls[language].get(fieldMap) as FormArray;
  }

  hasItemInScores(item: SegmentFieldItem): boolean {
    return false;
    // return _.has(this.segmentScores, `${item.item_name}.${this.selectedLanguage}`);
  }

  hasLoopingItemInScores(item: SegmentFieldItem, index: number): boolean {
    return false;
    // return _.has(this.segmentScores, `${item.item_name}.${this.selectedLanguage}.${index}`);
  }

  isLoopingFieldMasked(item: SegmentFieldItem, i: number): boolean {
    return true;
    // return this.hasScores ? (!this.hasItemInScores(item) && !this.hasLoopingItemInScores(item, i)) : false;
  }


  onSelectTypeahead(event: any, fieldName: string, formGroup: UntypedFormGroup, index: number) {
    this.formGroup.patchValue({
      'filename': event.item.filename,
      'file_path': event.item.file_path || event.item.uri,
      'asset_type': event.item.asset_type,
      'representation': event.item.representation,

      'description': event.item.description,
      'additional_info': event.item.additional_info,
      'color_mode': event.item.color_mode,
      'resolution': event.item.resolution,
      'background': event.item.background,
      'orientation_view': event.item.orientation_view,
      'file_date_modified': event.item.file_date_modified,
      'effective_date': event.item.effective_date,
      'expiration_date': event.item.expiration_date,
      'country': event.item.country,
      'language': event.item.language,

      'file_type': event.item.file_type,
      'width': event.item.width,
      'height': event.item.height,
      'uom': event.item.uom,
      'file_size': event.item.file_size,
      'third_party_asset': event.item.third_party_asset,

      'thumbnail': event.item.thumbnail,

      'frame': event.item.frame,
      'total_frame': event.item.total_frame,
      'hemisphere': event.item.hemisphere,
      'plunge': event.item.plunge,
      'plane': event.item.plane,
      'total_planes': event.item.total_planes,
      'duration': event.item.duration,
      'duration_uom': event.item.duration_uom,
      'descriptions': event.item.descriptions,
    });
  }

  onDateChange(selectedDate: string, item: any, formGroup: UntypedFormGroup, index: number) {
    if (item.field_map === 'expirationDate') {
      dateUtils.handleDateAheadChange(
        formGroup.get('effectiveDate'),
        'effectiveDate',
        selectedDate,
        this.segmentData,
        index
      );
    }
  }

  onSelectChange(option: Option, item: any) {
  }

  onControlStatusChange(option: Option, item: any) {
  }

  onControlFocus(item: any) {
  }

  onPartTypeClick() {
  }

  onControlPopulatedChange(option: any, item: any) {
  }

  onControlValueChange(searchValue: string, item: any) {
    this.digitalAssetsService.searchAssets(this.brandId, searchValue)
      .pipe(finalize(() => {}))
      .subscribe((res: any) => {
        this.searchAssetArray = res.data ? res.data : [];
        if (this.searchAssetArray.length === 1) {
          this.formGroup.patchValue({
            'third_party_asset': this.searchAssetArray[0].third_party_asset,
          });
        } else if (this.searchAssetArray.length > 0) {
          const equalAsset =  this.searchAssetArray.find(asset => asset.filename === this.formGroup.value.filename);
          this.formGroup.patchValue({
            'third_party_asset': equalAsset ? equalAsset.third_party_asset : 0,
          });
        }
        this.ref.markForCheck();
      });
  }

  private buildLoopingFormArray(itemDetail: any, item: SegmentFieldItem, language: string, validators: Array<any>) {
    const oData: any = _.get(itemDetail, item.item_name + '.' + language.toUpperCase());
    const formGroup: any = this.formGroup.controls[language.toLowerCase()];
    let formArray: any = formGroup.get(item.field_map);
    // reset formArray if array already has data
    if (formArray.length) {
      formGroup.setControl(item.field_map, new UntypedFormArray([]));
      formArray = formGroup.get(item.field_map);
    }
    if (oData) {
      _.each(oData, (desc) => {
        formArray.push(new UntypedFormControl(desc,  validators));
      });
    } else {
      // always add one empty element to the controls array
      formArray.push(new UntypedFormControl('',  validators));
    }

  }

  getItemValidation(item: SegmentFieldItem): any {
    const scoreRule = this.getItemScoreRule(item);
    return this.getItemValidationByRuleName(item, _.get(scoreRule, 'validation_rule'));
  }

  protected getItemValidationByRuleName(item: SegmentFieldItem, ruleName: string): any {
    const validationRules = _.get(item, `validation.${ruleName}`, {});
    // pies67 === pies65
    if (_.isEmpty(validationRules) && ruleName === 'pies67') {
      return _.get(item, `validation.pies65`, {});
    }
    return validationRules;
  }

  getDescriptions() {
    this.notNullDescriptionsCheck();
    return this.formGroup?.controls['descriptions'].value;
  }

  onChangeDescriptions($event) {
    this.formGroup.controls['descriptions'].setValue($event);
  }

  notNullDescriptionsCheck() {
    if (this.formGroup?.controls['descriptions'].value === null) {
      this.formGroup?.controls['descriptions'].setValue({});
    }
  }

  onLoopingControlStatusChange(status: any, item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlStatusChanged.emit({
    //   status, item, index, language: this.selectedLanguage
    // });
  }
  onLoopingControlFocus(item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlFocused.emit({
    //   item, index, language: this.selectedLanguage
    // });
  }
  onTextPopulatedChange(populated: number, item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlPopulatedChanged.emit({
    //   populated, item, index, language: this.selectedLanguage
    // });
  }
  // protected getFieldValidators(item: SegmentFieldItem): Array<ValidatorFn> {
    // const score = this.getScorecardField(item.item_name);
    // const validationRule = _.get(score, 'validation_rule'); // pies65, pies64, etc
    // const required = _.get(score, 'required', false);
    // const validation = this.getItemValidationByRuleName(item, validationRule);
    // validation.conditionals = null;
    // validation.required = required;
    //
    // // find all conditionals where item is in 'required' -
    // // we need to find what fields it depends on
    // const conditionals = this.getRequiredConditionalsForField(item.item_name); // from scorecard item, 'custom_validation_rules'
    //
    // if (conditionals) {
    //   validation.required = null;
    //   validation.conditionals = createScoreFieldRequiredValidation(conditionals);
    // }
    //
    // return this.initValidators(validation, this);
  // }

  protected getItemScoreRule(item: any): any {
    // return _.get(this.getItemScore(item), 'rule');
  }
}
